import types from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  employeeReport: [],
};

export default function employeeReportReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_EMPLOYEE_ACTIVITY_REPORT_REQUEST:
    case types.FETCH_MY_ACTIVITY_REPORT_REQUEST:
    case types.FETCH_AGE_WISE_REPORT_REQUEST:
    case types.FETCH_BIRTHDAY_REPORT_REQUEST:
    case types.FETCH_EXEMPTION_RESIGNED_REPORT_REQUEST:
      return { ...state, loading: true, error: null, success: false };


    case types.FETCH_EMPLOYEE_ACTIVITY_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_MY_ACTIVITY_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_AGE_WISE_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_BIRTHDAY_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_EXEMPTION_RESIGNED_REPORT_SUCCESS:
      return { ...state, loading: false, employeeReport: action.payload };

    case types.FETCH_EMPLOYEE_ACTIVITY_REPORT_FAILURE:
    case types.FETCH_MY_ACTIVITY_REPORT_FAILURE:
    case types.FETCH_AGE_WISE_REPORT_FAILURE:
    case types.FETCH_BIRTHDAY_REPORT_FAILURE:
    case types.FETCH_EXEMPTION_RESIGNED_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.RESET_EMPLOYEE_REPORT:
      return { ...initialState };
      
    default:
      return state;
  }
}
